<template>
    <div>
        <page-navigate></page-navigate>
        <div class="rongyuPage" style="background-color: #f7f7f7;overflow: hidden;">
            <section class="section1">
                <img src="@/assets/image/rongyu/section1Model.webp" alt="" class="section1Model pc">
                <div class="contentBox">
                    <h1 class="super_large-72_bold md-title-32_bold">全球最佳券商</h1>
                    <h2 class="title-32_regular md-subtitle-18_regular">
                        每一座奖杯，都回应着您的期许
                    </h2>
                </div>
            </section>
            <section class="section2">
                <div class="contentBox">
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo1.png" alt="" />
                        <div>全球最佳券商</div>
                        <div>Professional Trader Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo2.png" alt="" />
                        <div>全球最佳交易平台</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo2.png" alt="" />
                        <div>最受信赖券商</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo3.png" alt="" />
                        <div>全球最佳CFD券商</div>
                        <div>ONLINE MONEY AWARDS <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo4.png" alt="" />
                        <div>最佳体验券商</div>
                        <div>FollowMe Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo4.png" alt="" />
                        <div>最透明交易券商</div>
                        <div>BrokersView Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo5.png" alt="" />
                        <div>卓越执行券商</div>
                        <div>Forex Brokers Award <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo6.png" alt="" />
                        <div>最受好评券商</div>
                        <div>FollowMe Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo6.png" alt="" />
                        <div>十大最受欢迎券商</div>
                        <div>FollowMe Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo7.png" alt="" />
                        <div>最受信赖券商</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo7.png" alt="" />
                        <div>最佳CFD券商</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo8.png" alt="" />
                        <div>全球最佳ECN券商</div>
                        <div>Global Forex Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo8.png" alt="" />
                        <div>全球新锐券商</div>
                        <div>Global Forex Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo9.png" alt="" />
                        <div>最佳外汇交易平台</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                    <div>
                        <img src="@/assets/image/rongyu/section2Logo9.png" alt="" />
                        <div>最佳交易执行</div>
                        <div>World Finance Awards <span>颁发</span></div>
                    </div>
                </div>
                <div class="showMore md-content-16_medium">
                    <span class="open">查看更多</span>
                    <span class="close">回到顶部</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_275_1290)">
                            <path
                                d="M14.9582 7.07485C15.1931 6.82194 15.5887 6.80713 15.8416 7.04189C16.0945 7.27673 16.1093 7.67232 15.8746 7.92527L10.4579 13.7586C10.3397 13.886 10.1735 13.9584 9.99974 13.9584C9.82595 13.9584 9.65983 13.886 9.54157 13.7586L4.1249 7.92527L4.08381 7.87644C3.89281 7.62372 3.92073 7.26209 4.15786 7.04189C4.395 6.82181 4.7574 6.82096 4.99527 7.03009L5.04124 7.07485L9.99974 12.4146L14.9582 7.07485Z"
                                fill="#A52933" />
                        </g>
                        <defs>
                            <clipPath id="clip0_275_1290">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </section>
            <section class="section3">
                <h2 class="scroll-fade-up text-center">相关新闻</h2>
                <div class="section3NewList over-hidden  scroll-fade-up">
                    <div class="news-list flex">
                        
                            <div class="news-li " v-for="(item,index) in newsList">
                                <div class="thumbnail">
                                    <div style="display:none">
                                        {{ item.published_time }}
                                    </div>
                                    <p style="display:none">{{ item.post_excerpt }}</p>
                                    <a :href="item.url"><img :src="item.thumbnail" 
                                        :alt="item.post_title" /></a>
                                    <a :href="item.url">
                                        <h3 class="body-16_medium">
                                            {{ item.post_title }}</h3>
                                    </a>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
            <message-v3></message-v3>
        </div>
        <page-footer></page-footer>
    </div>
</template>
<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import seamscroll from '../assets/js/seamless.min.js'

import { mapGetters } from 'vuex';

export default {
    mixins: [fadeAnimate],
    data() {
        return {
            newsList:[]
        }
    },
    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            document.querySelector('.showMore').addEventListener('click', () => {
                document.querySelector('.section2').classList.toggle('showAll')
            })
            document.querySelector('.close').addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            })
            fetch('https://academy.ebccfd.com/api/honor-news').then(res=>res.json()).then(res=>{
                this.newsList = res.data.basic
                   setTimeout(()=>{
                seamscroll.init({
                dom: document.getElementsByClassName("news-list")[0],
                direction: 2,
                step: 0.8,
                hoverStep: 0.4,
                hoverStop: false,
            });
            })
            })
        }
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
a {
    text-decoration: none !important;
}

.contentBox {
    width: 1200rem;
    max-width: 100%;
    margin-inline: auto;
}

.section1 {
    padding-block: calc(80px + 150rem) 342rem;
    background: url('../assets/image/rongyu/section1Bg.webp');
    background-size: 100% 100%;
    position: relative;
}

.section1Model {
    position: absolute;
    width: 713rem;
    height: auto;
    right: calc(50vw - 960rem + 195rem);
    top: 84rem;
}

@media (min-width: 996px) {
    .ar .section1Model {
        right: unset;
        left: calc(50vw - 960rem + 195rem);
    }
}

.section1 h2 {
    margin-top: 24rem;
    color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
    .section1 {
        background: url('../assets/image/rongyu/section1Bgm.webp');
        background-size: cover;
        background-position: center;
        padding: calc(640rem + 90px) 32rem 106rem;
        margin-top: -45px;

    }

    .section1 h2 {
        margin-top: 16rem;
    }

    .section1 h2,
    .section1 h1 {
        text-align: center;
    }
}

.section2 {
    margin-top: -120rem;
    position: relative;
    z-index: 2;
}

.section2 .contentBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 24rem;
    padding-bottom: 48rem;
}

.section2 .contentBox>div {
    flex: 0 0 384rem;
    padding: 80rem 30rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: var(--Corner-Radius-RC08, 8px);
    background: var(--Neutral-BG_A, #FFF);
}

.section2 .contentBox>div:hover {
    box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.08);
}

.section2 .contentBox>div div:nth-child(2) {
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 20rem;
    font-weight: 600;
    line-height: 28rem;
    /* 140% */
    margin-top: auto;
}

.section2 .contentBox>div div:nth-child(3) {
    color: var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
    text-align: center;
    font-size: 16rem;
    font-weight: 500;
    line-height: 24rem;
    margin-top: 4rem;
}

.section2 .contentBox>div img {
    width: auto;
    height: 120rem;
    margin-bottom: 35rem;
}

.section2 .showMore {
    display: none;
}

@media (max-width: 996px) {
    .section2 {
        margin-top: -70rem;
        padding: 48rem 32rem;
    }

    .section2 .contentBox {
        flex-direction: column;
        padding-bottom: 32rem;

    }

    .section2 .contentBox>div {
        flex: 1;
    }

    .section2 .contentBox>div img {
        height: 230rem;
        margin-bottom: 80rem;
    }

    .section2 .contentBox>div div:nth-child(2) {
        font-size: 40rem;
        font-weight: 600;
        line-height: 56rem;
        /* 140% */
    }

    .section2 .contentBox>div div:nth-child(3) {
        font-size: 32rem;
        font-weight: 500;
        line-height: 48rem;
        margin-top: 8rem;
    }

    .section2 .showMore {
        display: block;
        color: #a52933;
        text-align: center;
        padding-block: 20rem;
    }

    .section2.showAll .open {
        display: none;
    }

    .section2.showAll .close {
        display: inline-block;
    }

    .section2 .open {
        display: inline-block;
    }

    .section2 .close {
        display: none;
    }

    .section2.showAll .showMore svg {
        transform: translateY(-5rem) rotate(180deg);
    }

    .section2 .contentBox>div:nth-child(n+7) {
        display: none;
    }

    .section2.showAll .contentBox>div:nth-child(n+7) {
        display: flex
    }

    .section2 .showMore svg {
        margin-left: 4rem;
        transform: translateY(-5rem);
    }
}

.section3 {
    padding-block: 160rem;
    overflow: hidden;
}

.section3 h2 {
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 48rem;
    font-weight: 700;
    line-height: 56rem;
    margin-bottom: 80rem;
}

.section3 .news-list {
    gap: 20rem;
    align-items: stretch;
}

.section3 .news-li {
    flex: 0 0 550rem;
    overflow: hidden;
    background: #fff;
    border-radius: var(--Corner-Radius-RC24, 24px);
    padding-bottom: 40rem;
}

.section3 .news-li img {
    width: 550rem;
    height: 360rem;
    border-radius: var(--Corner-Radius-RC24, 24px);
    margin-bottom: 32rem;
}

.section3 .news-li h3 {
    color: #000;
    font-size: 16rem;
    font-weight: 500;
    line-height: 24rem;
    /* 150% */
    padding-inline: 32rem;
}

@media (max-width: 996px) {
    .section3 {
        padding-block: 40rem 112rem;
    }

    .section3 h2 {
        line-height: 72rem;
        margin-bottom: 56rem;
    }

    .section3 .news-li {
        flex: 0 0 600rem;
        padding-bottom: 40rem;
        border-radius: 8px;
    }

    .section3 .news-li h3 {
        padding-inline: 40rem;
        font-size: 32rem;
        font-weight: 500;
        line-height: 48rem;
    }

    .section3 .news-li img {
        width: 600rem;
        height: 400rem;
        margin-bottom: 40rem;
        border-radius: 8px;

    }
}
</style>
